import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { UserPageHeaderComponent } from './user-page-header.component';

@NgModule({
    imports: [CommonModule, RouterModule],
    declarations: [UserPageHeaderComponent],
    exports: [UserPageHeaderComponent]
})
export class UserPageHeaderModule {}
